import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

export const DashboardNoData = memo(() => {
  const { t } = useTranslation();

  return (
    <Box
      sx={(t) => ({
        mt: 2,
        width: "100%",
        height: "100%",
        minHeight: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: t.palette.background.default,
        border: `1px solid ${t.palette.divider}`,
        borderRadius: 2,
      })}
    >
      <Typography>{t("components.panel.no_data")}</Typography>
    </Box>
  );
});
